/* LUNEA v2.4 — LifeStyle Privé
   Fiche produit : picker variante, bundle -20% dès 2 avec choix du modèle par pièce,
   ATC AJAX -> cart drawer Horizon. Cart drawer enrichi : compteur de réservation,
   barre livraison offerte, timeline de livraison, cross-sell. Zéro dépendance. */
(function () {
  'use strict';

  var FREE_SHIP_CENTS = 5000;         /* livraison offerte dès 50 € */
  var RESERVE_MS = 5 * 60 * 1000;     /* durée du "panier réservé" */
  var CROSS_CACHE = {};               /* cache /products/<handle>.js */

  function money(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }
  function pad(n) { return n < 10 ? '0' + n : '' + n; }
  function fdate(d) { return pad(d.getDate()) + '/' + pad(d.getMonth() + 1); }

  var SVG_BAG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"><path d="M6 8h12l-1 12H7L6 8Z"/><path d="M9 8a3 3 0 0 1 6 0"/></svg>';
  var SVG_TRUCK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"><path d="M3 7h11v8H3zM14 10h4l3 3v2h-7z"/><circle cx="7.5" cy="17.5" r="1.6"/><circle cx="17" cy="17.5" r="1.6"/></svg>';
  var SVG_BOX = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"><path d="M12 3l8 4v10l-8 4-8-4V7l8-4Z"/><path d="M4 7l8 4 8-4M12 11v10"/></svg>';

  /* ---------- Cart drawer Horizon : refresh + open ---------- */
  function drawerWrapper() {
    return document.getElementById('shopify-section-cart-drawer-section');
  }

  function openDrawer() {
    var el = document.getElementById('cart-drawer');
    if (!el) { window.location.href = '/cart'; return; }
    customElements.whenDefined('theme-drawer').then(function () {
      if (typeof el.open === 'function') el.open();
      else el.setAttribute('open', '');
    });
  }

  function refreshDrawer(sectionsHtml) {
    var wrap = drawerWrapper();
    if (!wrap || !sectionsHtml) return;
    var doc = new DOMParser().parseFromString(sectionsHtml, 'text/html');
    var fresh = doc.getElementById('shopify-section-cart-drawer-section') || doc.body.firstElementChild;
    if (fresh) wrap.replaceWith(fresh);
  }

  /* ---------- En-tête enrichi (réservation + livraison offerte + timeline) ---------- */
  function buildCartHead(content, cart) {
    var head = content.querySelector('[data-ln-carthead]');
    if (!head) {
      head = document.createElement('div');
      head.className = 'ln-carthead';
      head.setAttribute('data-ln-carthead', '');
      var now = new Date();
      var d1 = now;
      var d2 = new Date(now.getTime() + 864e5);
      var d3 = new Date(now.getTime() + 3 * 864e5);
      head.innerHTML =
        '<div class="ln-reserve">Panier réservé pendant <b><span data-ln-timer>05:00</span></b></div>' +
        '<div class="ln-ship" data-ln-ship><div class="ln-ship__txt"></div><div class="ln-ship__bar"><i></i></div></div>' +
        '<div class="ln-timeline">' +
          '<div class="ln-tl-step"><span class="ln-tl-ic">' + SVG_BAG + '</span><b>' + fdate(d1) + '</b><small>Commande prête</small></div>' +
          '<div class="ln-tl-step"><span class="ln-tl-ic">' + SVG_TRUCK + '</span><b>' + fdate(d2) + '</b><small>Expédition</small></div>' +
          '<div class="ln-tl-step"><span class="ln-tl-ic">' + SVG_BOX + '</span><b>' + fdate(d3) + '</b><small>Livraison</small></div>' +
        '</div>';
      content.insertBefore(head, content.firstChild);
    }
    var bar = head.querySelector('[data-ln-ship]');
    var total = cart.total_price;
    var txt = bar.querySelector('.ln-ship__txt');
    var fill = bar.querySelector('.ln-ship__bar i');
    var pct = Math.min(100, Math.round((total / FREE_SHIP_CENTS) * 100));
    if (total >= FREE_SHIP_CENTS) {
      txt.innerHTML = '<b>Livraison offerte débloquée</b> 🎁';
      bar.classList.add('is-unlocked');
    } else {
      txt.innerHTML = 'Plus que <b>' + money(FREE_SHIP_CENTS - total) + '</b> pour la livraison offerte';
      bar.classList.remove('is-unlocked');
    }
    fill.style.width = pct + '%';
  }

  var timerRunning = false;
  function startTimer() {
    if (timerRunning) return;
    timerRunning = true;
    setInterval(function () {
      var el = document.querySelector('[data-ln-timer]');
      if (!el) return;
      var until = parseInt(sessionStorage.getItem('lnReserveUntil') || '0', 10);
      var now = Date.now();
      if (!until || until <= now) { until = now + RESERVE_MS; sessionStorage.setItem('lnReserveUntil', String(until)); }
      var s = Math.max(0, Math.round((until - now) / 1000));
      el.textContent = Math.floor(s / 60) + ':' + (s % 60 < 10 ? '0' : '') + (s % 60);
    }, 1000);
  }

  /* ---------- Cross-sell "Craquez aussi pour…" ---------- */
  function fetchProduct(handle) {
    if (CROSS_CACHE[handle]) return Promise.resolve(CROSS_CACHE[handle]);
    return fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (p) { CROSS_CACHE[handle] = p; return p; });
  }

  function buildUpsell(wrap, cart) {
    var content = wrap.querySelector('.cart-drawer__content');
    var summary = wrap.querySelector('.cart-drawer__summary');
    if (!content || !summary) return;
    var has = {};
    cart.items.forEach(function (it) { has[it.handle] = true; });
    var target = (has['robe-magique'] && !has['pantalon-alma']) ? 'pantalon-alma'
      : (has['pantalon-alma'] && !has['robe-magique']) ? 'robe-magique'
      : null;
    var existing = wrap.querySelector('[data-ln-upsell]');
    if (!target) { if (existing) existing.remove(); return; }
    if (existing && existing.dataset.handle === target) return;

    fetchProduct(target).then(function (p) {
      var av = p.variants.filter(function (v) { return v.available; });
      var price = (av[0] || p.variants[0]).price;
      var opts = p.variants.map(function (v) {
        return '<option value="' + v.id + '"' + (v.available ? '' : ' disabled') + '>' + v.options[0] + '</option>';
      }).join('');
      var img = p.featured_image || (p.images && p.images[0]) || '';
      var box = wrap.querySelector('[data-ln-upsell]');
      if (!box) { box = document.createElement('div'); box.className = 'ln-upsell'; box.setAttribute('data-ln-upsell', ''); }
      box.dataset.handle = target;
      box.innerHTML =
        '<div class="ln-upsell__head">Craquez aussi pour…</div>' +
        '<div class="ln-upsell__card">' +
          '<img class="ln-upsell__img" src="' + img + '" alt="' + (p.title || '') + '" loading="lazy">' +
          '<div class="ln-upsell__mid">' +
            '<div class="ln-upsell__name">' + p.title + '</div>' +
            '<div class="ln-upsell__price">' + money(price) + '</div>' +
            '<select class="ln-upsell__sel" data-ln-upsell-sel aria-label="Choix">' + opts + '</select>' +
          '</div>' +
          '<button type="button" class="ln-upsell__add" data-ln-upsell-add>Ajouter</button>' +
        '</div>';
      if (!box.parentNode) content.insertBefore(box, summary);
      var sel = box.querySelector('[data-ln-upsell-sel]');
      if (av[0]) sel.value = String(av[0].id);
      box.querySelector('[data-ln-upsell-add]').addEventListener('click', function () {
        var btn = this;
        if (btn.disabled) return;
        btn.disabled = true; btn.textContent = 'Ajout…';
        addToCart([{ id: parseInt(sel.value, 10), quantity: 1 }]).catch(function () {
          btn.disabled = false; btn.textContent = 'Ajouter';
        });
      });
    }).catch(function () {});
  }

  /* ---------- Orchestration extras + observer ---------- */
  function renderDrawerExtras() {
    var wrap = drawerWrapper();
    if (!wrap) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var content = wrap.querySelector('.cart-drawer__content');
        if (!content || !cart.item_count) {
          var h = wrap.querySelector('[data-ln-carthead]'); if (h) h.remove();
          var u = wrap.querySelector('[data-ln-upsell]'); if (u) u.remove();
          return;
        }
        buildCartHead(content, cart);
        buildUpsell(wrap, cart);
        startTimer();
      })
      .catch(function () {});
  }

  function watchDrawer() {
    var wrap = drawerWrapper();
    if (!wrap || !('MutationObserver' in window)) return;
    if (watchDrawer.ob) watchDrawer.ob.disconnect();
    var t = null;
    watchDrawer.ob = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var n = muts[i].target;
        if (n && n.closest && (n.closest('[data-ln-carthead]') || n.closest('[data-ln-upsell]'))) return;
      }
      clearTimeout(t);
      t = setTimeout(renderDrawerExtras, 180);
    });
    watchDrawer.ob.observe(wrap, { childList: true, subtree: true });
    renderDrawerExtras();
  }

  /* Ajout panier AJAX ; items = [{id, quantity}] */
  function addToCart(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: items,
        sections: 'cart-drawer-section',
        sections_url: window.location.pathname
      })
    }).then(function (r) {
      if (!r.ok) throw new Error('add.js ' + r.status);
      return r.json();
    }).then(function (data) {
      if (data.sections && data.sections['cart-drawer-section']) {
        refreshDrawer(data.sections['cart-drawer-section']);
      }
      watchDrawer();
      openDrawer();
    });
  }

  /* ---------- Fiche produit ---------- */
  function initProduct(root) {
    var data = root.querySelector('[data-ln-product-json]');
    if (!data) return;
    var product;
    try { product = JSON.parse(data.textContent); } catch (e) { return; }

    var media = product.media || [];
    var variants = product.variants || [];
    var discountPct = parseFloat(root.dataset.discountPct || '20');

    var mainImg = root.querySelector('[data-ln-main-img]');
    var thumbsWrap = root.querySelector('[data-ln-thumbs]');
    var picks = Array.prototype.slice.call(root.querySelectorAll('.ln-pick'));
    var priceEl = root.querySelector('[data-ln-price]');
    var stickyPrice = root.querySelector('[data-ln-sticky-price]');
    var variantInput = root.querySelector('[data-ln-variant-id]');
    var qtyInput = root.querySelector('[data-ln-qty]');
    var badge = root.querySelector('[data-ln-badge]');
    var tiers = Array.prototype.slice.call(root.querySelectorAll('.ln-tier'));
    var unitsWrap = root.querySelector('[data-ln-units]');
    var unitRows = Array.prototype.slice.call(root.querySelectorAll('[data-ln-unit]'));
    var form = root.querySelector('form[data-ln-form]');

    var current = variants[0] ? variants[0].id : null;
    var selectedFromUrl = new URLSearchParams(window.location.search).get('variant');
    if (selectedFromUrl) {
      var m = variants.filter(function (v) { return String(v.id) === selectedFromUrl; })[0];
      if (m) current = m.id;
    }

    function variantById(id) {
      return variants.filter(function (v) { return v.id === id; })[0] || variants[0];
    }

    /* Galerie : médias dont l'alt commence par le nom de la variante, sinon tous */
    function mediaFor(variant) {
      if (!variant) return media;
      var name = (variant.option1 || variant.title || '').toLowerCase();
      var match = media.filter(function (mm) {
        return (mm.alt || '').toLowerCase().indexOf(name) === 0;
      });
      return match.length ? match : media;
    }

    function renderGallery(variant) {
      var list = mediaFor(variant);
      if (!list.length || !mainImg) return;
      mainImg.src = list[0].src;
      mainImg.alt = list[0].alt || product.title;
      if (thumbsWrap) {
        thumbsWrap.innerHTML = '';
        list.forEach(function (mm, i) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'ln-thumb';
          b.setAttribute('aria-current', i === 0 ? 'true' : 'false');
          b.setAttribute('aria-label', 'Photo ' + (i + 1));
          var im = document.createElement('img');
          im.src = mm.thumb || mm.src; im.alt = mm.alt || product.title; im.loading = 'lazy';
          b.appendChild(im);
          b.addEventListener('click', function () {
            mainImg.src = mm.src;
            Array.prototype.forEach.call(thumbsWrap.children, function (c) { c.setAttribute('aria-current', 'false'); });
            b.setAttribute('aria-current', 'true');
          });
          thumbsWrap.appendChild(b);
        });
        thumbsWrap.classList.toggle('ln-hidden', list.length < 2);
      }
    }

    function tierMath(unitCents, qty) {
      var full = unitCents * qty;
      if (qty < 2) return { now: full, old: null, save: null };
      var now = Math.round(full * (1 - discountPct / 100));
      return { now: now, old: full, save: full - now };
    }

    function renderTiers(variant) {
      var unit = variant ? variant.price : 0;
      tiers.forEach(function (t) {
        var qty = parseInt(t.dataset.qty, 10) || 1;
        var m2 = tierMath(unit, qty);
        var nowEl = t.querySelector('.ln-tier__now');
        var oldEl = t.querySelector('.ln-tier__old');
        var saveEl = t.querySelector('.ln-tier__save');
        if (nowEl) nowEl.textContent = money(m2.now);
        if (oldEl) { oldEl.textContent = m2.old ? money(m2.old) : ''; oldEl.classList.toggle('ln-hidden', !m2.old); }
        if (saveEl) { saveEl.textContent = m2.save ? '– ' + money(m2.save) : ''; saveEl.classList.toggle('ln-hidden', !m2.save); }
      });
    }

    function selectedQty() {
      var t = tiers.filter(function (x) { return x.dataset.selected === 'true'; })[0];
      return t ? (parseInt(t.dataset.qty, 10) || 1) : 1;
    }

    /* Sélecteurs par pièce (visibles dès 2) */
    function renderUnits() {
      if (!unitsWrap) return;
      var qty = selectedQty();
      unitsWrap.classList.toggle('ln-hidden', qty < 2);
      unitRows.forEach(function (row) {
        var n = parseInt(row.dataset.lnUnit, 10);
        row.classList.toggle('ln-hidden', n > qty);
      });
    }

    function syncUntouchedUnits() {
      unitRows.forEach(function (row) {
        var sel = row.querySelector('[data-ln-unit-select]');
        if (sel && !sel.dataset.touched) sel.value = String(current);
      });
    }

    function unitItems() {
      var qty = selectedQty();
      if (qty < 2) return [{ id: current, quantity: 1 }];
      var counts = {};
      unitRows.slice(0, qty).forEach(function (row) {
        var sel = row.querySelector('[data-ln-unit-select]');
        var id = sel ? parseInt(sel.value, 10) : current;
        counts[id] = (counts[id] || 0) + 1;
      });
      return Object.keys(counts).map(function (id) {
        return { id: parseInt(id, 10), quantity: counts[id] };
      });
    }

    function renderPrice(variant) {
      if (!variant) return;
      var qty = selectedQty();
      var m3 = tierMath(variant.price, qty);
      if (priceEl) priceEl.textContent = money(m3.now);
      if (stickyPrice) stickyPrice.textContent = money(m3.now) + (qty > 1 ? ' · ' + qty + ' pièces' : '');
    }

    function setVariant(id) {
      current = id;
      var v = variantById(id);
      if (variantInput) variantInput.value = v.id;
      picks.forEach(function (p) {
        p.setAttribute('aria-pressed', String(parseInt(p.dataset.variantId, 10) === v.id));
      });
      if (badge) badge.textContent = v.option1 || v.title;
      renderGallery(v);
      renderTiers(v);
      renderPrice(v);
      syncUntouchedUnits();
      var label = root.querySelector('[data-ln-picked-label]');
      if (label) label.textContent = v.option1 || v.title;
    }

    picks.forEach(function (p) {
      p.addEventListener('click', function () {
        if (p.dataset.unavailable === 'true') return;
        setVariant(parseInt(p.dataset.variantId, 10));
      });
    });

    tiers.forEach(function (t) {
      t.addEventListener('click', function () {
        tiers.forEach(function (x) { x.dataset.selected = 'false'; });
        t.dataset.selected = 'true';
        var r = t.querySelector('input[type="radio"]');
        if (r) r.checked = true;
        if (qtyInput) qtyInput.value = t.dataset.qty || '1';
        renderPrice(variantById(current));
        renderUnits();
      });
    });

    unitRows.forEach(function (row) {
      var sel = row.querySelector('[data-ln-unit-select]');
      if (sel) sel.addEventListener('change', function () { sel.dataset.touched = '1'; });
    });

    /* ATC AJAX -> drawer (fallback : formulaire natif) */
    var busy = false;
    function submitAjax(btn) {
      if (busy) return;
      busy = true;
      if (btn) { btn.dataset.label = btn.textContent; btn.textContent = 'Ajout…'; btn.disabled = true; }
      addToCart(unitItems())
        .catch(function () { if (form) form.submit(); })
        .then(function () {
          if (btn) { btn.textContent = btn.dataset.label || 'Ajouter au panier'; btn.disabled = false; }
          busy = false;
        });
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        submitAjax(form.querySelector('button[type="submit"]'));
      });
    }

    /* Sticky bar mobile : visible après avoir scrollé au-delà du CTA principal */
    var sticky = root.querySelector('[data-ln-sticky]');
    var atc = root.querySelector('[data-ln-atc-anchor]');
    if (sticky && atc && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        sticky.classList.toggle('is-visible', !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0);
      }, { threshold: 0 });
      io.observe(atc);
      var stickyBtn = sticky.querySelector('[data-ln-sticky-cta]');
      if (stickyBtn) stickyBtn.addEventListener('click', function () { submitAjax(stickyBtn); });
    }

    setVariant(current);
    renderUnits();
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    Array.prototype.forEach.call(document.querySelectorAll('[data-ln-product]'), initProduct);
    watchDrawer();
  });
})();
